import { useState, useEffect, useCallback } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { DrugCodeAxiosInstance } from "Network/DrugCodeAxiosInstance";
const ListOfDrugCode = ({ onChange, clear, defaultValue }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  // loadOptions
  const loadOptions = useCallback(async () => {
    if (inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);

    try {
      const response = await DrugCodeAxiosInstance.get(
        `getDrugsCode?desc=${encodeURIComponent(inputValue)}`
      );
      console.log("activitycode response:", response.data);

      const data = response.data?.result || [];

      const filteredData = data.filter((item: any) =>
        item.ddc_code?.toLowerCase().includes(inputValue.toLowerCase()) ||
        item.trade_name?.toLowerCase().includes(inputValue.toLowerCase())
      );

      const formattedOptions: Option[] = filteredData.map((item: any) => ({
        value: item.ddc_code, 
        label: `${item.ddc_code} - ${item.trade_name || ""} (${item.scientific_name || ""})`,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error loading drug codes:", error);
    } finally {
      setLoading(false);
    }
  }, [inputValue]);

  // Call load when searching
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      loadOptions();
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [inputValue, loadOptions]);

  // Update the selected values
  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  // Reset selected values when clearing values
  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);

  // Set default values on load
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);

  // styles
  const customStyles: StylesConfig<Option, true> = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#007BFF",
      color: "#FFFFFF",
      borderRadius: "5px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#FFFFFF",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#007BFF" : "#FFFFFF",
      color: isSelected ? "#FFFFFF" : "#000000",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
  };

  return (
    <Select
      isMulti
      value={selectedOptions}
      onChange={handleChange}
      options={options}
      isLoading={loading}
      onInputChange={setInputValue}
      placeholder="Type at least 3 letters to search..."
      styles={customStyles}
    />
  );
};

export default ListOfDrugCode;